/**
 * Image class
 * @private
 */
export class Image {
}
